declare namespace $ {

	type $mol_status__status_bog_vmap_app_inspect_value_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['alarm'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $bog_vmap_app_inspect_value_string__tree_bog_vmap_app_inspect_value_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_string['tree'] >
	>
	type $bog_vmap_app_inspect_value_string__editable_bog_vmap_app_inspect_value_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_string['editable'] >
	>
	type $mol_string__hint_bog_vmap_app_inspect_value_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_value_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['num'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_value_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_check__title_bog_vmap_app_inspect_value_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['flag_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_vmap_app_inspect_value_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['flag'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__enabled_bog_vmap_app_inspect_value_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_value_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_value_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['raw'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $bog_vmap_app_inspect_value_seq__tree_bog_vmap_app_inspect_value_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['tree'] >
	>
	type $bog_vmap_app_inspect_value_seq__keyed_bog_vmap_app_inspect_value_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['seq_keyed'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['keyed'] >
	>
	type $bog_vmap_app_inspect_value_seq__klass_bog_vmap_app_inspect_value_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['seq_klass'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['klass'] >
	>
	type $bog_vmap_app_inspect_value_seq__binds_bog_vmap_app_inspect_value_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['binds'] >
	>
	type $bog_vmap_app_inspect_value_seq__nodes_bog_vmap_app_inspect_value_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['nodes'] >
	>
	type $bog_vmap_app_inspect_value_seq__note_bog_vmap_app_inspect_value_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['note'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['note'] >
	>
	type $bog_vmap_app_inspect_value_seq__path_bog_vmap_app_inspect_value_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['path'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['path'] >
	>
	type $bog_vmap_app_inspect_value_seq__share_able_bog_vmap_app_inspect_value_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['share_able'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['share_able'] >
	>
	type $bog_vmap_app_inspect_value_seq__share_mark_bog_vmap_app_inspect_value_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['share_mark'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['share_mark'] >
	>
	type $bog_vmap_app_inspect_value_seq__share_bog_vmap_app_inspect_value_21 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['share'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['share'] >
	>
	type $bog_vmap_app_inspect_value_seq__share_unshare_bog_vmap_app_inspect_value_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['share_unshare'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['share_unshare'] >
	>
	type $bog_vmap_app_inspect_value_seq__alarm_bog_vmap_app_inspect_value_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['alarm'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['alarm'] >
	>
	type $bog_vmap_app_inspect_value_seq__editable_bog_vmap_app_inspect_value_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_seq['editable'] >
	>
	type $bog_vmap_app_inspect_value_bind__tree_bog_vmap_app_inspect_value_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_bind['tree'] >
	>
	type $bog_vmap_app_inspect_value_bind__binds_bog_vmap_app_inspect_value_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_bind['binds'] >
	>
	type $bog_vmap_app_inspect_value_bind__nodes_bog_vmap_app_inspect_value_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_bind['nodes'] >
	>
	type $bog_vmap_app_inspect_value_bind__alarm_bog_vmap_app_inspect_value_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['alarm'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_bind['alarm'] >
	>
	type $bog_vmap_app_inspect_value_bind__editable_bog_vmap_app_inspect_value_29 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_bind['editable'] >
	>
	type $bog_vmap_app_inspect_value_wire__tree_bog_vmap_app_inspect_value_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_wire['tree'] >
	>
	type $bog_vmap_app_inspect_value_wire__nodes_bog_vmap_app_inspect_value_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_wire['nodes'] >
	>
	type $bog_vmap_app_inspect_value_wire__alarm_bog_vmap_app_inspect_value_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['alarm'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_wire['alarm'] >
	>
	type $bog_vmap_app_inspect_value_wire__editable_bog_vmap_app_inspect_value_33 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_wire['editable'] >
	>
	export class $bog_vmap_app_inspect_value extends $mol_list {
		editors( ): readonly($mol_view)[]
		num( next?: string ): string
		flag_title( ): string
		flag( next?: boolean ): boolean
		raw( ): string
		seq_keyed( ): boolean
		seq_klass( ): boolean
		tree( next?: $mol_tree2_empty ): $mol_tree2_empty
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		alarm( next?: string ): string
		note( ): string
		path( ): string
		share_able( id: any): boolean
		share_mark( id: any): string
		share( id: any, next?: any ): any
		share_unshare( id: any, next?: any ): any
		editable( ): boolean
		rows( ): ReturnType< $bog_vmap_app_inspect_value['editors'] >
		Alarm( ): $mol_status
		String( ): $bog_vmap_app_inspect_value_string
		Num( ): $mol_string
		Flag( ): $mol_check
		Raw( ): $mol_string
		Seq( ): $bog_vmap_app_inspect_value_seq
		Bind( ): $bog_vmap_app_inspect_value_bind
		Wire( ): $bog_vmap_app_inspect_value_wire
	}
	
	export class $bog_vmap_app_inspect_value_area extends $mol_string {
		rows( ): number
		dom_name( ): string
		attr( ): ({ 
			'rows': ReturnType< $bog_vmap_app_inspect_value_area['rows'] >,
		})  & ReturnType< $mol_string['attr'] >
		plugins( ): readonly(any)[]
	}
	
	type $bog_vmap_app_inspect_value_area__hint_bog_vmap_app_inspect_value_string_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_inspect_value_area['hint'] >
	>
	type $bog_vmap_app_inspect_value_area__rows_bog_vmap_app_inspect_value_string_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_string['text_rows'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_area['rows'] >
	>
	type $bog_vmap_app_inspect_value_area__value_bog_vmap_app_inspect_value_string_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_string['text'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_area['value'] >
	>
	type $bog_vmap_app_inspect_value_area__enabled_bog_vmap_app_inspect_value_string_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_string['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_area['enabled'] >
	>
	type $mol_check__title_bog_vmap_app_inspect_value_string_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_vmap_app_inspect_value_string_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_vmap_app_inspect_value_string_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_string['locale'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__enabled_bog_vmap_app_inspect_value_string_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_string['editable'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	export class $bog_vmap_app_inspect_value_string extends $mol_bar {
		text_rows( ): number
		text( next?: string ): string
		Text( ): $bog_vmap_app_inspect_value_area
		locale( next?: boolean ): boolean
		Locale( ): $mol_check
		tree( next?: $mol_tree2_empty ): $mol_tree2_empty
		editable( ): boolean
		sub( ): readonly(any)[]
	}
	
	type $mol_status__status_bog_vmap_app_inspect_value_seq_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_string__hint_bog_vmap_app_inspect_value_seq_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_value_seq_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['class_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_value_seq_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_list__rows_bog_vmap_app_inspect_value_seq_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['items'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_value_seq_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['add_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_value_seq_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_value_seq_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_value_seq_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $bog_vmap_app_inspect_value_item__keyed_bog_vmap_app_inspect_value_seq_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['keyed'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['keyed'] >
	>
	type $bog_vmap_app_inspect_value_item__marker_bog_vmap_app_inspect_value_seq_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_marker'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['marker'] >
	>
	type $bog_vmap_app_inspect_value_item__key_bog_vmap_app_inspect_value_seq_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_key'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['key'] >
	>
	type $bog_vmap_app_inspect_value_item__value_bog_vmap_app_inspect_value_seq_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_value'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['value'] >
	>
	type $bog_vmap_app_inspect_value_item__binds_bog_vmap_app_inspect_value_seq_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['binds'] >
	>
	type $bog_vmap_app_inspect_value_item__nodes_bog_vmap_app_inspect_value_seq_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['nodes'] >
	>
	type $bog_vmap_app_inspect_value_item__drop_bog_vmap_app_inspect_value_seq_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_drop'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['drop'] >
	>
	type $bog_vmap_app_inspect_value_item__path_bog_vmap_app_inspect_value_seq_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['item_path'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['path'] >
	>
	type $bog_vmap_app_inspect_value_item__share_able_bog_vmap_app_inspect_value_seq_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['share_able'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['share_able'] >
	>
	type $bog_vmap_app_inspect_value_item__share_mark_bog_vmap_app_inspect_value_seq_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['share_mark'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['share_mark'] >
	>
	type $bog_vmap_app_inspect_value_item__share_bog_vmap_app_inspect_value_seq_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['share'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['share'] >
	>
	type $bog_vmap_app_inspect_value_item__share_unshare_bog_vmap_app_inspect_value_seq_21 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['share_unshare'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['share_unshare'] >
	>
	type $bog_vmap_app_inspect_value_item__editable_bog_vmap_app_inspect_value_seq_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_seq['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
	>
	export class $bog_vmap_app_inspect_value_seq extends $mol_list {
		seq_sub( ): readonly($mol_view)[]
		class_name( next?: string ): string
		items( ): readonly($mol_view)[]
		add_title( ): string
		item_add( next?: any ): any
		item_marker( id: any): boolean
		item_key( id: any, next?: string ): string
		item_value( id: any, next?: $mol_tree2_empty ): $mol_tree2_empty
		item_drop( id: any, next?: any ): any
		item_path( id: any): string
		tree( next?: $mol_tree2_empty ): $mol_tree2_empty
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		alarm( next?: string ): string
		keyed( ): boolean
		klass( ): boolean
		note( ): string
		path( ): string
		share_able( id: any): boolean
		share_mark( id: any): string
		share( id: any, next?: any ): any
		share_unshare( id: any, next?: any ): any
		editable( ): boolean
		rows( ): ReturnType< $bog_vmap_app_inspect_value_seq['seq_sub'] >
		Note( ): $mol_status
		Class_name( ): $mol_string
		Items( ): $mol_list
		Add( ): $mol_button_minor
		Item( id: any): $bog_vmap_app_inspect_value_item
	}
	
	type $mol_button_minor__title_bog_vmap_app_inspect_value_item_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_value_item_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_value_item_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['share_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_value_item_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_value_item_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_value_item_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_value_item_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['unshare_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_value_item_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_view__sub_bog_vmap_app_inspect_value_item_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['mark_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_bog_vmap_app_inspect_value_item_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_value_item_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_value_item_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $bog_vmap_app_inspect_value__tree_bog_vmap_app_inspect_value_item_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['value'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
	>
	type $bog_vmap_app_inspect_value__binds_bog_vmap_app_inspect_value_item_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
	>
	type $bog_vmap_app_inspect_value__nodes_bog_vmap_app_inspect_value_item_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
	>
	type $bog_vmap_app_inspect_value__editable_bog_vmap_app_inspect_value_item_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
	>
	type $mol_button_minor__title_bog_vmap_app_inspect_value_item_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_bog_vmap_app_inspect_value_item_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_vmap_app_inspect_value_item_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['drop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_bog_vmap_app_inspect_value_item_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_item['editable'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	export class $bog_vmap_app_inspect_value_item extends $mol_bar {
		item_sub( ): readonly($mol_view)[]
		share_click( next?: any ): any
		unshare_click( next?: any ): any
		mark_sub( ): readonly($mol_view_content)[]
		key( next?: string ): string
		value( next?: $mol_tree2_empty ): $mol_tree2_empty
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		keyed( ): boolean
		marker( ): boolean
		drop( next?: any ): any
		path( ): string
		share_able( id: any): boolean
		share_mark( id: any): string
		share( id: any, next?: any ): any
		share_unshare( id: any, next?: any ): any
		editable( ): boolean
		sub( ): ReturnType< $bog_vmap_app_inspect_value_item['item_sub'] >
		Share( ): $mol_button_minor
		Unshare( ): $mol_button_minor
		Mark( ): $mol_view
		Key( ): $mol_string
		Value( ): $bog_vmap_app_inspect_value
		Drop( ): $mol_button_minor
	}
	
	type $mol_select__hint_bog_vmap_app_inspect_value_bind_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_vmap_app_inspect_value_bind_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['target'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_vmap_app_inspect_value_bind_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['binds'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__enabled_bog_vmap_app_inspect_value_bind_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['editable'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $bog_vmap_app_inspect_value__tree_bog_vmap_app_inspect_value_bind_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['default_value'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
	>
	type $bog_vmap_app_inspect_value__binds_bog_vmap_app_inspect_value_bind_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
	>
	type $bog_vmap_app_inspect_value__nodes_bog_vmap_app_inspect_value_bind_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
	>
	type $bog_vmap_app_inspect_value__editable_bog_vmap_app_inspect_value_bind_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_bind['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
	>
	export class $bog_vmap_app_inspect_value_bind extends $mol_bar {
		bind_sub( ): readonly($mol_view_content)[]
		target( next?: string ): string
		default_value( next?: $mol_tree2_empty ): $mol_tree2_empty
		tree( next?: $mol_tree2_empty ): $mol_tree2_empty
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		alarm( next?: string ): string
		editable( ): boolean
		sub( ): ReturnType< $bog_vmap_app_inspect_value_bind['bind_sub'] >
		Target( ): $mol_select
		Default( ): $bog_vmap_app_inspect_value
	}
	
	type $mol_bar__sub_bog_vmap_app_inspect_value_wire_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['wire_row'] >
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_select__hint_bog_vmap_app_inspect_value_wire_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_vmap_app_inspect_value_wire_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['origin'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_vmap_app_inspect_value_wire_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['node_names'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__enabled_bog_vmap_app_inspect_value_wire_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['editable'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__hint_bog_vmap_app_inspect_value_wire_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_vmap_app_inspect_value_wire_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['port'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_vmap_app_inspect_value_wire_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['ports'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__enabled_bog_vmap_app_inspect_value_wire_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['editable'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_string__hint_bog_vmap_app_inspect_value_wire_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_value_wire_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['port'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_value_wire_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_status__status_bog_vmap_app_inspect_value_wire_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_value_wire['note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	export class $bog_vmap_app_inspect_value_wire extends $mol_list {
		wire_sub( ): readonly($mol_view)[]
		wire_row( ): readonly($mol_view_content)[]
		origin( next?: string ): string
		node_names( ): readonly(string)[]
		port( next?: string ): string
		ports( ): readonly(string)[]
		note( ): string
		tree( next?: $mol_tree2_empty ): $mol_tree2_empty
		nodes( ): Record<string, any>
		alarm( next?: string ): string
		wire_op( ): string
		wire_dot( ): string
		editable( ): boolean
		rows( ): ReturnType< $bog_vmap_app_inspect_value_wire['wire_sub'] >
		Row( ): $mol_bar
		Origin( ): $mol_select
		Port_pick( ): $mol_select
		Port_free( ): $mol_string
		Note( ): $mol_status
	}
	
}

//# sourceMappingURL=value.view.tree.d.ts.map